import { trans } from "@/service/i18n/i18n";

import { Button } from "@/components/ui/button";
import { DialogClose, DialogContent } from "@/components/ui/dialog";
import { getAssetImage } from "@/service/image/asset";

export const NilDetails = ({ closeModal }: { closeModal: () => void }) => (
  <DialogContent className={"w-[320px]"} innerClassName={`p-4`}>
    <h5 className={"text-center text-lg"}>{trans("user.nil.modal.title")}</h5>
    <p className={"text-muted-foreground my-4 text-sm"}>
      {trans("user.nil.modal.content")}
    </p>
    <img
      src={getAssetImage("/registration/nil.png")}
      alt="nil"
      className={"absolute top-4 left-4 w-4"}
    />
    <Button variant={"secondary"} className={"w-full"} onClick={closeModal}>
      {trans("user.nil.modal.agree")}
    </Button>
    <DialogClose />
  </DialogContent>
);
